$(document).ready(function () {
 //   $('.fulltext').hide();

    $('.readmore').click(function (event) {
        event.preventDefault();
        var description = document.querySelector('.rte--header');
        if (description.style.height === ''){
          description.style.height = 'auto';
          $(".rte--header").removeClass("fade-bottom");
        } else if (description.style.height === 'auto'){
          description.style.height = '';
          $(".rte--header").addClass("fade-bottom");
        }
        else{
          description.style.height = '220px';
        }
        
        $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
    });
});